import { createTheme } from '@mui/material';
import typography from './typography';

const theme = createTheme({
  palette: {
    type: 'light',
    primary: {
      main: '#036fcb',
      light: '#00a0df',
      disabled: '#8BC5F5',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f5f5',
    },
    paper: {
      main: '#fff',
    },
  },
  typography,
});

export default theme;
